import { render, staticRenderFns } from "./ServiciosConexion.vue?vue&type=template&id=670519b8&"
import script from "./ServiciosConexion.vue?vue&type=script&lang=js&"
export * from "./ServiciosConexion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports